<template>
    <checker-detail-row>
        <h5>Departing At</h5>
        <div class="form-groups">
            <div class="form-group">
                <div class="input-chevron-icon"/>
                <datepicker
                    id="end_date"
                    ref="endDatePicker"
                    :options="dateConfig"
                    v-model="dateVal"
                    :disabled="disabled"
                    class="datepicker form-control v2-styles dropdown-arrow"
                    name="end_date"
                />
            </div>
            <div class="form-group">
                <div class="input-chevron-icon"/>
                <timepicker
                    id="end_time"
                    :options="timeConfig"
                    v-model="timeVal"
                    :disabled="disabled"
                    class="timepicker form-control v2-styles dropdown-arrow"
                    name="end_time"
                />
            </div>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from './CheckerDetailRow';
    import Timepicker from '../../forms/Timepicker';
    import Datepicker from '../../forms/Datepicker';
    import BaseDateTimeInput from './BaseDateTimeInput';

    export default {
        name: 'departure-input',

        components: {
            BaseDateTimeInput,
            Datepicker,
            Timepicker,
            CheckerDetailRow,
        },

        mixins: [BaseDateTimeInput],
    };
</script>
